import { TieredDropdownProps } from '@procore/core-react/dist/_typedoc/TieredDropdown/TieredDropdown.types.json';
import * as React from 'react';
export default {
  TieredDropdownProps,
  React
};